
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl } from '../base.component';
import { EventService } from '../service/event.service';
import { ServiceLocatorService } from '../service/service-locator.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent extends BaseCtl {
  constructor(public locator: ServiceLocatorService,
    private eService: EventService, public route: ActivatedRoute) {
    super(locator.endpoints.PUBLIC, locator, route);
  }

  ngOnInit() {
    let _self = this;
  
    //_self.form.data["appId"] = 1603808081614;
//    _self.form.data["appId"] = 1605767792296;
  // _self.form.data["orgId"] = 1618396720966; //for powertech
  // _self.form.data["role"] = "Visitor";
   // _self.form.data["orgId"] = 1618396706542; // for NCS
  
    
  }

  populateForm(form, data) {
    super.populateForm(form, data);
    form.data.firstName = data.firstName;
    form.data.lastName = data.lastName;
    form.data.login = data.login;
    form.data.password = data.password;
     form.data.role = data.role ;
  }


  isLogin = false;
  
  signup() {
    var _self = this;

    _self.form.data["appId"] = _self.locator.endpoints.PNAC_APPID;
    _self.form.data["orgId"] = _self.locator.endpoints.POWERTECH_ORGID;
    _self.form.data["role"] = "Visitor"

    console.log(_self.form);
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.PUBLIC, "signUpVis");

    this.locator.http.post(url, this.form.data, function (res, error) {

       console.log('response', res);
      _self.form.message = '';
      _self.form.inputerror = {};

      //console.log("1");
      if(res.success){
        _self.isLogin = true;
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
      _self.form.inputerror = res.result.inputerror;
    });
  }
}
